import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import NewsEditor from "components/News/NewsEditor";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

function UpdateNews() {
  const { id } = useParams();
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [notification, setNotification] = useState({
    open: false,
    color: "success",
    message: "",
  });

  useEffect(() => {
    const loadNews = async () => {
      if (init() !== "success") {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${Constants.getUrls.getSingleNews}${id}`);
        setInitialValues(response?.data?.data || null);
      } catch (error) {
        setNotification({
          open: true,
          color: "error",
          message: error?.response?.data?.message || "Unable to load news details.",
        });
      } finally {
        setLoading(false);
      }
    };

    loadNews();
  }, [id]);

  const handleSubmit = async (form) => {
    if (init() !== "success") {
      return;
    }

    setSubmitLoading(true);

    try {
      const fd = new FormData();
      fd.append("news_title", form.news_title);
      fd.append("summary", form.summary);
      fd.append("seo_title", form.seo_title);
      fd.append("seo_description", form.seo_description);
      fd.append("seo_keywords", form.seo_keywords);
      fd.append("status", form.status);
      fd.append("news_content", form.news_content);
      fd.append(
        "related_testseries",
        JSON.stringify(form.related_testseries.map((item) => item.value))
      );

      if (form.news_poster) {
        fd.append("news_poster", form.news_poster);
      }

      const response = await axios.put(`${Constants.putUrls.updateNews}${id}`, fd);
      setNotification({
        open: true,
        color: "success",
        message: response?.data?.message || "News updated successfully.",
      });

      setTimeout(() => {
        setRedirect(true);
      }, 1200);
    } catch (error) {
      setNotification({
        open: true,
        color: "error",
        message: error?.response?.data?.message || "Unable to update news.",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  if (redirect) {
    return <Navigate to="/news" />;
  }

  if (loading) {
    return null;
  }

  return (
    <NewsEditor
      title="Update News"
      submitLabel="Update News"
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitLoading={submitLoading}
      notification={notification.open}
      notificationColor={notification.color}
      notificationMessage={notification.message}
    />
  );
}

export default UpdateNews;
